// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__VlQw-","reportBodyText":"style__reportBodyText__I5vxE"};